import { AccountsTableActionBar } from "./accounts-action-bar";
import { DuplicateNamesWarning } from "./duplicate-names-warning";
import { DataTable } from "./table";

export function AccountsTable<TData, TValue>() {
  return (
    <div className="flex flex-col pb-4 gap-4">
      <DuplicateNamesWarning />
      <div className="flex-1 min-h-0">
        <DataTable>
          <AccountsTableActionBar />
        </DataTable>
      </div>
    </div>
  );
}
